import React from 'react'

import PropTypes from 'prop-types'
import classNames from 'classnames'
import TextField from '@material-ui/core/TextField'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import FormControl from '@material-ui/core/FormControl'
import FormHelperText from '@material-ui/core/FormHelperText'

import SubmitButton from 'components/atoms/buttons/SubmitButton'

export const styles = theme => ({
  root: {
    width: 424,
    textAlign: 'center',
    padding: `0 ${theme.spacing(4)}px`,
  },
  form: {
    marginTop: theme.spacing(2),
  },
  errorMessage: {
    padding: `${theme.spacing(2)}px 0`,
  },
  formControl: {
    marginBottom: theme.spacing(2),
  },
  submitButton: {
    marginTop: theme.spacing(2),
  },
  actions: {
    maxWidth: 360,
    display: 'flex',
    margin: '0 auto',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    marginTop: theme.spacing(1),
  },
  disclaimer: {
    left: 0,
    right: 0,
    bottom: -16,
    textAlign: 'left',
    position: 'absolute',
    fontSize: '12px !important',
    color: theme.palette.disabled.main,
  },
})

const EditTrapForm = ({
  data,
  errors,
  values,
  classes,
  isSubmitting,
  hasFieldError,
  handleFormSubmit,
  handleFieldChange,
  // handleTrapDeleteClick,
  className: classNameProp,
}) => {
  const className = classNames(classes.root, classNameProp)
  return (
    <div className={className}>
      <Typography variant="h1">Edit Trap</Typography>
      <form
        className={classes.form}
        noValidate
        autoComplete="off"
        onSubmit={handleFormSubmit}>
        <FormControl
          className={classes.formControl}
          fullWidth
          error={hasFieldError('name')}>
          <TextField
            name="name"
            type="name"
            id="name-input"
            margin="normal"
            label="Trap Name"
            inputProps={{
              maxLength: 1024,
            }}
            autoComplete="name"
            value={values.name}
            onChange={handleFieldChange}
            error={hasFieldError('name')}
          />
          {hasFieldError('name') ? (
            <FormHelperText>{errors.name}</FormHelperText>
          ) : null}
          {!data.trapName && values.name === data.serial ? (
            <Typography className={classes.disclaimer}>
              We are using serial number here, as no name has been set
            </Typography>
          ) : null}
        </FormControl>
        <FormControl
          className={classes.formControl}
          fullWidth
          error={hasFieldError('latitude')}>
          <TextField
            name="latitude"
            type="coordinate"
            id="latitude-input"
            margin="normal"
            label="Latitude"
            autoComplete="latitude"
            value={values.latitude}
            onChange={handleFieldChange}
            error={hasFieldError('latitude')}
          />
          {hasFieldError('latitude') ? (
            <FormHelperText>{errors.latitude}</FormHelperText>
          ) : null}
        </FormControl>
        <FormControl
          className={classes.formControl}
          fullWidth
          error={hasFieldError('longitude')}>
          <TextField
            name="longitude"
            type="coordinate"
            id="longitude-input"
            margin="normal"
            label="Longitude"
            autoComplete="longitude"
            value={values.longitude}
            onChange={handleFieldChange}
            error={hasFieldError('longitude')}
          />
          {hasFieldError('longitude') ? (
            <FormHelperText>{errors.longitude}</FormHelperText>
          ) : null}
        </FormControl>
        <FormControl
          className={classNames(classes.formControl, classes.actions)}
          fullWidth>
          {/* <SubmitButton
            autoFocus
            size='medium'
            color='primary'
            variant='secondary'
            disabled={isSubmitting}
            onClick={handleTrapDeleteClick}
            className={classes.submitButton}>
            Delete trap
          </SubmitButton> */}
          <SubmitButton
            autoFocus
            size="medium"
            type="submit"
            color="primary"
            variant="primary"
            disabled={isSubmitting}
            className={classes.submitButton}>
            Update
          </SubmitButton>
        </FormControl>
      </form>
    </div>
  )
}

EditTrapForm.propTypes = {
  data: PropTypes.object,
  values: PropTypes.object,
  errors: PropTypes.object,
  status: PropTypes.string,
  className: PropTypes.string,
  isSubmitting: PropTypes.bool,
  apiCallError: PropTypes.bool,
  hasFieldError: PropTypes.func,
  errorMessage: PropTypes.string,
  handleFormSubmit: PropTypes.func,
  handleFieldChange: PropTypes.func,
  classes: PropTypes.object.isRequired,
  handleTrapDeleteClick: PropTypes.func,
}

export default withStyles(styles)(EditTrapForm)



// WEBPACK FOOTER //
// ./src/components/organisms/EditTrapForm/EditTrapForm.js